import React from 'react';

const Layout = (props) => {
    return (
        <React.Fragment>
            <div className="content-head">
                <h1>Explore</h1>
            </div>
            <div className="content-main bg">
                {props.children}
            </div>
        </React.Fragment>
    )
}
export default Layout;
